(ns bec-core.cljs.views.venues
  (:require [reagent.core :as r] 
            [re-frame.core :as rf]
            [bec-cljs-common.components.icon :refer [icon]]
            [bec-cljs-common.components.input :as input]
            [bec-cljs-common.components.button :as button]
            [bec-cljs-common.utils.css :as css]))

(defn information [& [props]]
  [:div.fade-in
   {:style {"--fade-in-duration" "1000ms"}}
   [:section.hero.is-danger
    [:div.hero-body
     [:div.container
      [:p.title "Venue"]
      [:p.subtitle "All systems are working ok"]
      [:p "23 notifications recieved since last you logged in"]]]]
   [:div.container.is-fluid
    {:style {:margin-top "1.5rem"}}
    [:button.button.has-margin
     {:on-click #(rf/dispatch [:select-view :dashboard])}
     "Go to dashboard"]
    [:button.button.has-margin
     {:on-click #(rf/dispatch [:select-view :home])}
     "Show home"]
    [:div.tile.is-ancestor
     [:div.tile.is-4
      [:div.tile
       [:div.tile.is-parent.is-vertical
        [:article.tile.is-child.box.is-clickable
         {:on-click #(rf/dispatch [:select-view :venue {:sub-view :information}])}
         [:div
          {:style {:display "flex"
                   :justify-content "center"
                   :align-items "center"
                   :flex-direction "column"
                   :text-align "center"}}
          [:div.box.is-rounded
           [icon
            {:size "5rem"}
            [:i.fas.fa-info]]]
          [:h1.title "Information"]]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:on-click #(rf/dispatch [:select-view :venue {:sub-view :actions}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          [icon
           {:size "5rem"}
           [:i.fas.fa-tools]]]
         [:h1.title "Actions"]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:on-click #(rf/dispatch [:select-view :venue {:sub-view :settings}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          [icon
           {:size "5rem"}
           [:i.fas.fa-cog]]]
         [:h1.title "Settings"]]]]]]]])

(defn pos-settings [& [props]]
  (let [keypad-id "venue-pos-iframe-url"
        keypad-props @(rf/subscribe [:keypad keypad-id])
        machines @(rf/subscribe [:machines])]
    [:div.panel-body.fade-in
     [:table.table
      {:style {:width "100%"}}
      [:tbody
       [:tr
        [:td
         [input/switch
          {:id "venue-pos-iframe-toggle"
           :class "is-rounded"
           :outer-style {:border-radius "var(--border-radius-large)"}
           :on-change (fn [event]
                        (println (.-checked (.-target event))))}
          "Toggle POS iframe"]]
        [:td
         {:style {:vertical-align "bottom"}}
         [button/button
          {:class "is-danger is-fullwidth is-outlined"
           :style {:margin 0}
           :on-click #(rf/dispatch [:core-shared-state [:common :darts-game-server :hello] "Hello"])}
          "Reset"]]]
       [:tr
        [:td
         [:div.field
          {:style {:width "100%"
                   :text-align "start"}}
          [:div.field.label.is-normal
           [:label "POS iframe URL"]]
          [:div.field-body
           [:div.field
            [:div.control
             {:style {:display "flex"}}
             [input/input
              {:id keypad-id
               :type "text"
               :placeholder "POS iframe URL"
               :value (:input keypad-props)
               :on-change #(rf/dispatch [:keyboard-button-press
                                         {:keypad-id keypad-id
                                          :input (-> % .-target .-value)}])}]]]]]]
        [:td
         {:style {:vertical-align "bottom"}}
         [button/button
          {:class "is-danger is-fullwidth is-outlined"
           :style {:margin 0}
           :on-click #(rf/dispatch [:core-shared-state [:common :darts-game-server :hello] "Hello"])}
          "Reset"]]]]]]))

(defonce dummy-value-hue (r/atom {}))
(defonce dummy-value-saturation (r/atom {}))
(defonce dummy-value-lightness (r/atom {}))

(defn tiles []
  [:div
   [:div.tile.is-ancestor
    [:div {:class "tile is-vertical is-6"}
     [:div {:class "tile"}
      [:div {:class "tile is-parent is-vertical"}
       [:p.title
        "Primary color"]
       [:article {:class "tile is-child box"}
        [:div.box
         [:p.subtitle (str "Hue: " (or (:primary @dummy-value-hue) 0) "°")]
         [:input.slider.hue.is-primary
          {:type "range"
           :min "0"
           :max "360"
           :step "1"
           :value (or (:primary @dummy-value-hue) 0)
           :on-change (fn [event]
                        (let [value (-> event .-target .-value)]
                          (swap! dummy-value-hue assoc :primary value)
                          (css/set-global-property "--primary-brand-color-hue" value)))}]]
        [:div.box
         [:p.subtitle (str "Saturation: " (or (:primary @dummy-value-saturation) 0) "%")]
         [:input.slider.is-primary
          {:type "range"
           :min "0"
           :max "100"
           :step "1"
           :value (or (:primary @dummy-value-saturation) 0)
           :on-change (fn [event]
                        (let [value (-> event .-target .-value)]
                          (swap! dummy-value-saturation assoc :primary value)
                          (css/set-global-property "--primary-brand-color-saturation" (str value "%"))))}]]
        [:div.box
         [:p.subtitle (str "Lightness: " (or (:primary @dummy-value-lightness) 0) "%")]
         [:input.slider.is-primary
          {:type "range"
           :min "0"
           :max "100"
           :step "1"
           :value (or (:primary @dummy-value-lightness) 0)
           :on-change (fn [event]
                        (let [value (-> event .-target .-value)]
                          (swap! dummy-value-lightness assoc :primary value)
                          (css/set-global-property "--primary-brand-color-lightness" (str value "%"))))}]]]]]]
    [:div.tile.is-6
     [:div {:class "tile is-parent is-vertical"}
      [:p.title
       "Blue sliders"]
      [:article {:class "tile is-child box"}
       [:article {:class "message is-link"}
        [:div {:class "message-header"}
         [:button {:class "delete"}]]
        [:div {:class "message-body"}
         "Lorem ipsum dolor sit amet."]]
       [:div.box
        [:p.subtitle (str "Saturation: " (or (:blue @dummy-value-saturation) 0) "%")]
        [:input.slider.is-link
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:blue @dummy-value-saturation) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-saturation assoc :blue value)
                         (css/set-global-property "--blue-saturation" (str value "%"))))}]]
       [:div.box
        [:p.subtitle (str "Lightness: " (or (:blue @dummy-value-lightness) 0) "%")]
        [:input.slider.is-link
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:blue @dummy-value-lightness) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-lightness assoc :blue value)
                         (css/set-global-property "--blue-lightness" (str value "%"))))}]]]]]]
   [:div.tile.is-ancestor
    [:div.tile.is-6
     [:div {:class "tile is-parent is-vertical"}
      [:p.title
       "Red sliders"]
      [:article {:class "tile is-child box"}
       [:article {:class "message is-danger"}
        [:div {:class "message-header"}
         [:button {:class "delete"}]]
        [:div {:class "message-body"}
         "Lorem ipsum dolor sit amet."]]
       [:div.box
        [:p.subtitle (str "Saturation: " (or (:red @dummy-value-saturation) 0) "%")]
        [:input.slider.is-danger
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:red @dummy-value-saturation) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-saturation assoc :red value)
                         (css/set-global-property "--red-saturation" (str value "%"))))}]]
       [:div.box
        [:p.subtitle (str "Lightness: " (or (:red @dummy-value-lightness) 0) "%")]
        [:input.slider.is-danger
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:red @dummy-value-lightness) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-lightness assoc :red value)
                         (css/set-global-property "--red-lightness" (str value "%"))))}]]]]]
    [:div {:class "tile is-vertical is-6"}
     [:div {:class "tile"}
      [:div {:class "tile is-parent is-vertical"}
       [:p.title
        "Cyan color"]
       [:article {:class "tile is-child box"}
        [:article {:class "message is-info"}
         [:div {:class "message-header"}
          [:button {:class "delete"}]]
         [:div {:class "message-body"}
          "Lorem ipsum dolor sit amet."]]
        [:div.box
         [:p.subtitle (str "Saturation: " (or (:cyan @dummy-value-saturation) 0) "%")]
         [:input.slider.is-info
          {:type "range"
           :min "0"
           :max "100"
           :step "1"
           :value (or (:cyan @dummy-value-saturation) 0)
           :on-change (fn [event]
                        (let [value (-> event .-target .-value)]
                          (swap! dummy-value-saturation assoc :cyan value)
                          (css/set-global-property "--cyan-saturation" (str value "%"))))}]]
        [:div.box
         [:p.subtitle (str "Lightness: " (or (:cyan @dummy-value-lightness) 0) "%")]
         [:input.slider.is-info
          {:type "range"
           :min "0"
           :max "100"
           :step "1"
           :value (or (:cyan @dummy-value-lightness) 0)
           :on-change (fn [event]
                        (let [value (-> event .-target .-value)]
                          (swap! dummy-value-lightness assoc :cyan value)
                          (css/set-global-property "--cyan-lightness" (str value "%"))))}]]]]]]]
   [:div.tile.is-ancestor
    [:div.tile.is-6
     [:div {:class "tile is-parent is-vertical"}
      [:p.title
       "Yellow sliders"]
      [:article {:class "tile is-child box"}
       [:article {:class "message is-warning"}
        [:div {:class "message-header"}
         [:button {:class "delete"}]]
        [:div {:class "message-body"}
         "Lorem ipsum dolor sit amet."]]
       [:div.box
        [:p.subtitle (str "Saturation: " (or (:yellow @dummy-value-saturation) 0) "%")]
        [:input.slider.is-warning
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:yellow @dummy-value-saturation) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-saturation assoc :yellow value)
                         (css/set-global-property "--yellow-saturation" (str value "%"))))}]]
       [:div.box
        [:p.subtitle (str "Lightness: " (or (:yellow @dummy-value-lightness) 0) "%")]
        [:input.slider.is-warning
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:yellow @dummy-value-lightness) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-lightness assoc :yellow value)
                         (css/set-global-property "--yellow-lightness" (str value "%"))))}]]]]]
    [:div.tile.is-6
     [:div {:class "tile is-parent is-vertical"}
      [:p.title
       "Green sliders"]
      [:article {:class "tile is-child box"}
       [:article {:class "message is-success"}
        [:div {:class "message-header"}
         [:button {:class "delete"}]]
        [:div {:class "message-body"}
         "Lorem ipsum dolor sit amet."]]
       [:div.box
        [:p.subtitle (str "Saturation: " (or (:green @dummy-value-saturation) 0) "%")]
        [:input.slider.is-success
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:green @dummy-value-saturation) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-saturation assoc :green value)
                         (css/set-global-property "--green-saturation" (str value "%"))))}]]
       [:div.box
        [:p.subtitle (str "Lightness: " (or (:green @dummy-value-lightness) 0) "%")]
        [:input.slider.is-success
         {:type "range"
          :min "0"
          :max "100"
          :step "1"
          :value (or (:green @dummy-value-lightness) 0)
          :on-change (fn [event]
                       (let [value (-> event .-target .-value)]
                         (swap! dummy-value-lightness assoc :green value)
                         (css/set-global-property "--green-lightness" (str value "%"))))}]]]]]]
   [:div.tile.is-ancestor
    [:div {:class "tile is-parent is-vertical is-6"}
     [:p.title
      "Scheme main color"]
     [:article {:class "tile is-child box"}
      [:div.box
       [:p.subtitle (str "Hue: " (or (:scheme-main @dummy-value-hue) 0) "°")]
       [:input.slider.hue
        {:type "range"
         :min "0"
         :max "360"
         :step "1"
         :value (or (:scheme-main @dummy-value-hue) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-hue assoc :scheme-main value)
                        (css/set-global-property "--scheme-main-hue" value)))}]]
      [:div.box
       [:p.subtitle (str "Saturation: " (or (:scheme-main @dummy-value-saturation) 0) "%")]
       [:input.slider
        {:type "range"
         :min "0"
         :max "100"
         :step "1"
         :value (or (:scheme-main @dummy-value-saturation) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-saturation assoc :scheme-main value)
                        (css/set-global-property "--scheme-main-saturation" (str value "%"))))}]]
      [:div.box
       [:p.subtitle (str "Lightness: " (or (:scheme-main @dummy-value-lightness) 0) "%")]
       [:input.slider
        {:type "range"
         :min "0"
         :max "100"
         :step "1"
         :value (or (:scheme-main @dummy-value-lightness) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-lightness assoc :scheme-main value)
                        (css/set-global-property "--scheme-main-lightness" (str value "%"))))}]]]]
    [:div {:class "tile is-parent is-vertical is-6"}
     [:p.title
      "Scheme invert color"]
     [:article {:class "tile is-child box"}
      [:div.box
       [:p.subtitle (str "Hue: " (or (:scheme-invert @dummy-value-hue) 0) "°")]
       [:input.slider.hue
        {:type "range"
         :min "0"
         :max "360"
         :step "1"
         :value (or (:scheme-invert @dummy-value-hue) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-hue assoc :scheme-invert value)
                        (css/set-global-property "--scheme-invert-hue" value)))}]]
      [:div.box
       [:p.subtitle (str "Saturation: " (or (:scheme-invert @dummy-value-saturation) 0) "%")]
       [:input.slider
        {:type "range"
         :min "0"
         :max "100"
         :step "1"
         :value (or (:scheme-invert @dummy-value-saturation) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-saturation assoc :scheme-invert value)
                        (css/set-global-property "--scheme-invert-saturation" (str value "%"))))}]]
      [:div.box
       [:p.subtitle (str "Lightness: " (or (:scheme-invert @dummy-value-lightness) 0) "%")]
       [:input.slider
        {:type "range"
         :min "0"
         :max "100"
         :step "1"
         :value (or (:scheme-invert @dummy-value-lightness) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-lightness assoc :scheme-invert value)
                        (css/set-global-property "--scheme-invert-lightness" (str value "%"))))}]]]]]
   [:div.tile.is-ancestor
    [:div {:class "tile is-parent is-vertical is-6"}
     [:p.title
      "Text color"]
     [:article {:class "tile is-child box"}
      [:div.box
       [:p.subtitle (str "Hue: " (or (:text-color @dummy-value-hue) 0) "°")]
       [:input.slider.hue
        {:type "range"
         :min "0"
         :max "360"
         :step "1"
         :value (or (:text-color @dummy-value-hue) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-hue assoc :text-color value)
                        (css/set-global-property "--text-hue" value)))}]]
      [:div.box
       [:p.subtitle (str "Saturation: " (or (:text-color @dummy-value-saturation) 0) "%")]
       [:input.slider
        {:type "range"
         :min "0"
         :max "100"
         :step "1"
         :value (or (:text-color @dummy-value-saturation) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-saturation assoc :text-color value)
                        (css/set-global-property "--text-saturation" (str value "%"))))}]]
      [:div.box
       [:p.subtitle (str "Lightness: " (or (:text-color @dummy-value-lightness) 0) "%")]
       [:input.slider
        {:type "range"
         :min "0"
         :max "100"
         :step "1"
         :value (or (:text-color @dummy-value-lightness) 0)
         :on-change (fn [event]
                      (let [value (-> event .-target .-value)]
                        (swap! dummy-value-lightness assoc :text-color value)
                        (css/set-global-property "--text-lightness" (str value "%"))))}]]]]]])

(defn rebranding-settings [& [props]]
  (let [keypad-id "venue-pos-iframe-url"
        keypad-props @(rf/subscribe [:keypad keypad-id])]
    [:div.panel-body.fade-in
     [:table.table
      {:style {:width "100%"}}
      [:tbody
       [:tr
        [:td
         [input/switch
          {:id "venue-pos-iframe-toggle"
           :class "is-rounded"
           :outer-style {:border-radius "6px"}}
          "Toggle POS iframe"]]
        [:td
         {:style {:vertical-align "bottom"}}
         [button/button
          {:class "is-danger is-fullwidth is-outlined"
           :style {:margin 0}
           :on-click #(rf/dispatch [:core-shared-state [:common :darts-game-server :hello] "Hello"])}
          "Reset"]]]
       [:tr
        [:td
         [:div.field
          {:style {:width "100%"
                   :text-align "start"}}
          [:div.field.label.is-normal
           [:label "POS iframe URL"]]
          [:div.field
           [:div.control
            {:style {:display "flex"}}
            [input/input
             {:id keypad-id
              :type "text"
              :placeholder "POS iframe URL"
              :value (:input keypad-props)
              :on-change #(rf/dispatch [:keyboard-button-press
                                        {:keypad-id keypad-id
                                         :input (-> % .-target .-value)}])}]]]]]
        [:td
         {:style {:vertical-align "bottom"}}
         [button/button
          {:class "is-danger is-fullwidth is-outlined"
           :style {:margin 0}
           :on-click #(rf/dispatch [:core-shared-state [:common :darts-game-server :hello] "Hello"])}
          "Reset"]]]
       [:tr
        [:td
         [:div.field
          {:style {:width "100%"
                   :text-align "start"}}
          [:div.field.label.is-normal
           [:label (str "Hue: " (or (:primary @dummy-value-hue) 0) "°")]]
          [:div.field
           {:style {:padding "1rem 0.5rem"}}
           [:div.control
            {:style {:display "flex"}}
            [:input.slider.hue.is-primary
             {:type "range"
              :min "0"
              :max "360"
              :step "1"
              :value (or (:primary @dummy-value-hue) 0)
              :on-change (fn [event]
                           (let [value (-> event .-target .-value)]
                             (swap! dummy-value-hue assoc :primary value)
                             (css/set-global-property "--primary-brand-color-hue" value)))}]]]]]
        [:td
         {:style {:vertical-align "bottom"}}
         [button/button
          {:class "is-danger is-fullwidth is-outlined"
           :style {:margin 0}
           :on-click #(rf/dispatch [:core-shared-state [:common :darts-game-server :hello] "Hello"])}
          "Reset"]]]
       [:tr
        [:td
         [:div.field
          {:style {:width "100%"
                   :text-align "start"}}
          [:div.field.label.is-normal
           [:label (str "Hue: " (or (:primary @dummy-value-hue) 0) "°")]]
          [:div.field
           {:style {:padding "1rem 0.5rem"}}
           [:div.control
            {:style {:display "flex"}}
            [:input.slider.hue.is-primary
             {:type "range"
              :min "0"
              :max "360"
              :step "1"
              :value (or (:primary @dummy-value-hue) 0)
              :on-change (fn [event]
                           (let [value (-> event .-target .-value)]
                             (swap! dummy-value-hue assoc :primary value)
                             (css/set-global-property "--primary-brand-color-hue" value)))}]]]]]
        [:td
         {:style {:vertical-align "bottom"}}
         [button/button
          {:class "is-danger is-fullwidth is-outlined"
           :style {:margin 0}
           :on-click #(rf/dispatch [:core-shared-state [:common :darts-game-server :hello] "Hello"])}
          "Reset"]]]]]]))

(defn setting-box [& [props]]
  (let [selected-setting (:selected-setting props)
        setting-title (:title props)
        setting-subtitle (:subtitle props)
        setting-type (:setting-type props)
        setting-active? (= selected-setting setting-type)
        setting-usable? (or (= setting-type :pos) #_(= setting-type :rebranding))
        checkbox @(rf/subscribe [:checkbox])]
    [:div.tile.fade-in
     {:class (if setting-active? "is-12" "is-6")
      :style {:display (when (and (not setting-active?) selected-setting) "none")}}
     [:div.tile.is-parent.is-vertical
      [:div.tile.is-child.box
       {:style {:position "relative"
                :width "100%"
                :filter "drop-shadow(0px 0px 0.0625rem var(--blue))"
                :text-align "center"}}
       [:div
        {:style {:display "flex"
                 :flex-direction "column"
                 :justify-content "space-between"
                 :height "100%"}}
        [:h1.title.is-spaced
         {:style {:font-size (when setting-active? "1.5rem")
                  :margin-bottom (when setting-active? "0.25rem")
                  :transition "font-size 250ms"}}
         setting-title]
        [:p.subtitle
         {:style {:font-size (when setting-active? "1rem")
                  :transition "font-size 250ms"}}
         setting-subtitle]
        (when setting-active?
          (case setting-type
            :pos [pos-settings props]
            :rebranding [rebranding-settings props]
            :seasonal-decorations [pos-settings props]
            :marketing [pos-settings props]))
        (if setting-active?
          [:div.panel-block.fade-in
           {:style {:overflow "auto"
                    :margin-top "1.5rem"}}
           [button/button
            {:class "is-fullwidth"
             :style {:margin "0.25rem 0.5rem 0.25rem 0"}
             :on-click #(rf/dispatch [:select-view :venues {:sub-view :settings}])}
            "Cancel"]
           [button/button
            {:class "is-success is-outlined is-fullwidth"
             :style {:margin "0.25rem 0 0.25rem 0.5rem"}
             :on-click #(rf/dispatch [:core-shared-state [:common :darts-game-server :hello] (get checkbox "venue-pos-iframe-toggle")])}
            "Confirm"]]
          [button/button
           {:class "is-link is-outlined is-fullwidth"
            :style {:margin "0"}
            :disabled (not setting-usable?)
            :on-click #(rf/dispatch [:select-view :venues {:sub-view :settings
                                                           :selected-setting setting-type}])}
           "Open"])]]]]))

(defn settings-options [& [props]]
  [:div.fade-in
   {:style {"--fade-in-duration" "1000ms"}}
   [:div.tile.is-ancestor
    {:style {:position "relative"}}
    [setting-box (merge props
                   {:title "POS"
                    :subtitle "Toggle POS and change iframe POS URL."
                    :setting-type :pos})]
    [setting-box (merge props
                   {:title "Rebranding"
                    :subtitle "Toggle rebranding, adjust color schemes and upload brand material."
                    :setting-type :rebranding})]]
   [:div.tile.is-ancestor
    {:style {:position "relative"}}
    [setting-box (merge props
                   {:title "Seasonal decorations"
                    :subtitle "Toggle seasonal decorations, change timings and upload new seasonal material."
                    :setting-type :seasonal-decorations})]
    [setting-box (merge props
                   {:title "Marketing"
                    :subtitle "Toggle promotions on and off, change timings and upload new promotional material."
                    :setting-type :marketing})]]])

(defn settings [& [props]]
  (let [venues (:venues props)]
    [:div.fade-in
     {:style {"--fade-in-duration" "1000ms"}}
     [:div.container.is-fluid
      {:style {:margin "1.5rem 0"}}
      (into
        [:div
         {:style {:text-align "center"
                  :margin-bottom "1.5rem"}}
         [:h1.title.is-spaced.is-1
          "Venue settings"]
         [:p.subtitle
          "Changes will apply to the venues below"]
         (map
           (fn [venue]
             [:span.tag.is-info
              {:key (:id (:venue (:information (first venue))))
               :style {:margin "0 0.25rem 0.25rem 0"}}
              (:id (:venue (:information (first venue))))
              [:button.is-clickable.glows
               {:style {:margin-left "0.25rem"}
                :on-click (fn []
                            (swap! input/variables assoc-in [:checkbox (:id (:venue (:information (first venue))))] 
                              false)
                            (when (= (count venues) 1)
                              (rf/dispatch [:select-view :venues])))}
               [:i.fas.fa-times-circle]]])
           venues)])
      [settings-options props]]]))

(defn actions [& [props]]
  [:div.fade-in
   {:style {"--fade-in-duration" "1000ms"}}
   [:div.container.is-fluid
    {:style {:margin-top "1.5rem"}}
    [:button.button.has-margin
     {:on-click #(rf/dispatch [:select-view :dashboard])}
     "Go to dashboard"]
    [:button.button.has-margin
     {:on-click #(rf/dispatch [:select-view :home])}
     "Show home"]
    [:div.tile.is-ancestor
     [:div.tile.is-4
      [:div.tile
       [:div.tile.is-parent.is-vertical
        [:article.tile.is-child.box.is-clickable
         {:on-click #(rf/dispatch [:select-view :venue {:sub-view :information}])}
         [:div
          {:style {:display "flex"
                   :justify-content "center"
                   :align-items "center"
                   :flex-direction "column"
                   :text-align "center"}}
          [:div.box.is-rounded
           [icon
            {:size "5rem"}
            [:i.fas.fa-info]]]
          [:h1.title "Information"]]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:on-click #(rf/dispatch [:select-view :venue {:sub-view :actions}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          [icon
           {:size "5rem"}
           [:i.fas.fa-tools]]]
         [:h1.title "Actions"]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:on-click #(rf/dispatch [:select-view :venue {:sub-view :settings}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          [icon
           {:size "5rem"}
           [:i.fas.fa-cog]]]
         [:h1.title "Settings"]]]]]]]])

(defn venue-selection [& [props]]
  (let [venues (:venues props)]
    [:div.panel-body
     {:style {:height "calc(100vh - 17rem)"
              :min-height "20vh"
              :overflow "auto"}}
     [:table.table
      {:style {:width "100%"}}
      [:thead
       {:style {:position "sticky"
                :top "-1px"
                :background "var(--scheme-main)"
                :z-index "1"}}
       [:tr
        [:th "Select"]
        [:th "Identifier"]
        [:th "Address"]
        [:th "Revenue type"]
        [:th "Country"]]]
      (into
        [:tbody]
        (map
          (fn [venue]
            (let [information (:information (first venue))]
              [:tr
               [:td
                {:style {:padding 0}}
                [input/checkbox
                 {:key (:id (:venue information))
                  :id (:id (:venue information))
                  :class "is-rounded"
                  :style {:text-align "start"}
                  :outer-style {:border-radius 0}}]]
               [:td (:id (:venue information))]
               [:td (:address (:venue information))]
               [:td (:revenue-type (:machine information))]
               [:td (:id (:country information))]]))
          venues))]]))

(defn list-view [& [props]]
  (let [keypad-props @(rf/subscribe [:keypad "venue-search-bar-input"])
        select-all? (not (= (count (:venues props)) (count (:selected-venues props))))]
    [:div.fade-in
     {:style {"--fade-in-duration" "1000ms"}}
     [:div.container.is-fluid
      [:section.section
       [:nav.panel.is-primary
        [:div.panel-heading
         {:style {:display "flex"
                  :justify-content "center"}}
         [:p (if (> (count (:selected-venues props)) 0)
               (str "Selected " (count (:selected-venues props)))
               "Select")]]
        [:div.panel-block
         {:style {:border-bottom "none"}}
         [button/button
          {:class "is-small"
           :style {:margin "0 0.25rem 0 0"}
           :on-click (fn []
                       (doseq [venue (:venues props)]
                         (swap! input/variables assoc-in [:checkbox (:id (:venue (:information (first venue))))] 
                           select-all?)))}
          (if select-all? "Select all" "Deselect all")]
         [:div.control.has-icons-left
          [input/input
           {:id "venue-search-bar-input"
            :type "text"
            :placeholder "Search"
            :value (:input keypad-props)
            :on-change #(rf/dispatch [:keyboard-button-press
                                      {:keypad-id "venue-search-bar-input"
                                       :input (-> % .-target .-value)}])}]
          [:span.icon.is-left
           [:i.fas.fa-search
            {:aria-hidden true}]]]]
        [venue-selection props]
        [:div.panel-block
         {:style {:overflow "auto"}}
         [button/button
          {:class "is-link is-outlined is-fullwidth"
           :style {:margin "0.25rem 0.5rem"}
           :disabled true}
          "Actions"]
         [button/button
          {:class "is-link is-outlined is-fullwidth"
           :style {:margin "0.25rem 0.5rem"}
           :disabled true}
          "Information"]
         [button/button
          {:class "is-link is-outlined is-fullwidth"
           :style {:margin "0.25rem 0.5rem"}
           :disabled (empty? (:selected-venues props))
           :on-click #(rf/dispatch [:select-view :venues {:sub-view :settings}])}
          "Settings"]]]]]]))

(defn view [& [props]]
  (let [checkboxes @(rf/subscribe [:checkbox])
        venues @(rf/subscribe [:venue-search])
        selected-venues (filter #(get checkboxes (:id (:venue (:information (first %))))) venues)
        augmented-props (merge props
                          {:venues venues
                           :selected-venues selected-venues})]
    (case (and (not (empty? selected-venues)) (:sub-view props))
      :information [information augmented-props]
      :settings [settings augmented-props]
      :actions [actions augmented-props]
      [list-view augmented-props])))